import React from "react";

import { TablePagination } from "@mui/material";
import { ConfirmModal } from "Component/ConfirmModal";
import CustomTable from "Component/CustomTable";
import { LoadingModal } from "Component/LoadingModal";
import { fetchApi } from "Config/fetchApi";
import { getUserInfo } from "Config/getUserInfo";
import { handleError, handleSuccess, paginate } from "Helper";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NAVIGATION } from "Route/ConstantRoute";
import useExportExcel from "./useExportExcel";

function IntentMenu() {
  const navigate = useNavigate();

  const { isLoading: exportLoading, exportExcel } = useExportExcel();

  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [keywordSearch, setDataKeyword] = useState("");
  const [dataOriginal, setDataOriginal] = useState([]);
  const [headerTable] = useState([
    {
      label: "Intents",
      key: "intentName",
      align: "center",
    },
    {
      label: "Total Context",
      key: "total_context",
      align: "center",
    },
    {
      label: "Total Phrase",
      key: "total_phrase",
      align: "center",
    },
    {
      label: "Total Respon",
      key: "total_response",
      align: "center",
    },
  ]);
  const [isActionTable] = useState({
    isAdd: true,
    isEdit: true,
    isShow: false,
    isDelete: true,
  });
  const [deleteModal, setDeleteModal] = useState({ show: false, data: null });

  const toggleDeleteModal = (data) => {
    console.log(data);
    setDeleteModal({ show: !deleteModal.show, data: data || null });
  };

  const onSearchData = async (keyword) => {
    setDataKeyword(keyword);
    if (keyword.trim() === "") {
      getData();
    } else {
      const filteredData = dataOriginal?.filter((item) => {
        const lowerCasedSearchText = keyword.toLowerCase();
        return item?.gender_name.toLowerCase().includes(lowerCasedSearchText);
      });

      setDataPaginate(paginate(filteredData, pageNumber, pageSize));
    }
  };

  const handleDelete = async () => {
    try {
      setIsSending(true);
      const row = deleteModal?.data;
      const response = await fetchApi().post(`/intent/delete/${row.id}`);

      handleSuccess(response?.data?.message);
      toggleDeleteModal();
      getData();
    } catch (error) {
      handleError(error);
    } finally {
      setIsSending(false);
    }
  };

  // ==================== Pengaturan Pagination ==================== //
  const [dataPaginate, setDataPaginate] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
    if (keywordSearch === "") {
      setDataPaginate(paginate(dataOriginal, newPage, pageSize));
    } else {
      const filteredData = dataOriginal?.filter((item) => {
        const lowerCasedSearchText = keywordSearch.toLowerCase();
        return item?.gender_name.toLowerCase().includes(lowerCasedSearchText);
      });
      setDataPaginate(paginate(filteredData, newPage, pageSize));
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    if (keywordSearch === "") {
      setDataPaginate(
        paginate(dataOriginal, pageNumber, parseInt(event.target.value, 10))
      );
    } else {
      const filteredData = dataOriginal?.filter((item) => {
        const lowerCasedSearchText = keywordSearch.toLowerCase();
        return item?.gender_name.toLowerCase().includes(lowerCasedSearchText);
      });
      setDataPaginate(
        paginate(filteredData, pageNumber, parseInt(event.target.value, 10))
      );
    }
  };
  // ==================== Pengaturan Pagination ==================== //
  const getData = async () => {
    try {
      setIsLoading(true);
      const userId = getUserInfo()?.userInfo?.id;
      const result = await fetchApi().get(`/intent/get-list/${userId}`);
      console.log(result);

      setDataOriginal(result?.data?.data);
      setDataPaginate(result?.data?.data);

      setIsLoading(false);
    } catch (err) {
      setDataOriginal([]);
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportExcel = async () => {
    try {
      setIsSending(true);
      const userId = getUserInfo()?.userInfo?.id;
      const resp = await fetchApi().get(
        `/intent/get-list/${userId}?page=0&size=all`
      );

      const columns = [
        {
          label: "Intent",
          key: "intentName",
          width: 30
        },
        {
          label: "Context",
          key: "context",
          width: 45,
        },
        {
          label: "Phrase",
          key: "phrase",
          width: 60
        },
        {
          label: "Response",
          key: "response",
          width: 60
        },
      ];

      const normalizedData = resp?.data?.data.map((el) => ({
        ...el,
        context: el.context.join("\n"),
        phrase: el.phrase.join("\n"),
        response: el.response.join("\n")
      }))

      exportExcel({ data: normalizedData, cols: columns, hasNumber: true });
    } catch (error) {
      console.log(error);
    } finally {
      setIsSending(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p className="text-2xl font-bold">Dataset Intents</p>
      </div>
      <CustomTable
        onClickCreate={() => {
          navigate(NAVIGATION.intent_create);
        }}
        isAction={isActionTable}
        onEditData={(data) => navigate(NAVIGATION.intent_edit, { state: data })}
        isLoading={isLoading}
        headerData={headerTable}
        Data={dataPaginate}
        onSearchData={onSearchData}
        onDeleteData={(val) => toggleDeleteModal(val)}
        exportExcel={handleExportExcel}
        TablePagination={
          <TablePagination
            rowsPerPageOptions={[15, 20, 30, 50]}
            component="div"
            count={dataOriginal.length}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
      />

      <ConfirmModal
        open={deleteModal.show}
        toggleModal={toggleDeleteModal}
        onConfirm={handleDelete}
      />

      <LoadingModal open={isSending} />
    </div>
  );
}

export default IntentMenu;
